export const EVENT_STATUS_FINISHED = 'finished';
export const EVENT_STATUS_FEATURED = 'featured';
export const EVENT_STATUS_UPCOMING = 'upcoming';

export const MAX_EVENT_REQUEST_LIMIT = 8;
